import { fg } from '@atlassian/jira-feature-gating';

// Embedders self-declare via a `parentProduct` query param on the embed URL (e.g.
// `/browse/KEY/embed?parentProduct=confluence`). A cross-origin iframe cannot read
// `window.top.location`, so this is the only way to know who is hosting us — see JIV-22235.
//
// The value originates from whoever embedded us, so treat it as untrusted: only accept a short,
// simple token rather than forwarding arbitrary strings into analytics.
const VALID_PARENT_PRODUCT = /^[a-zA-Z0-9_-]{1,50}$/;

export const getParentProduct: () => string | undefined = () => {
	if (!fg('platform_embed_parent_product_attribution')) {
		return undefined;
	}

	try {
		// Optional chaining off globalThis keeps this safe during SSR, where there is no window
		const search = globalThis.window?.location?.search;

		if (!search) {
			return undefined;
		}

		const parentProduct = new URLSearchParams(search).get('parentProduct');

		if (parentProduct === null || !VALID_PARENT_PRODUCT.test(parentProduct)) {
			return undefined;
		}

		return parentProduct;
	} catch (e) {
		// Never let an analytics attribute break the page
		return undefined;
	}
};
